<script setup lang="ts">
import { RouterView } from 'vue-router';
import { ref } from 'vue';
import FsumNav from '@/components/Navigation/FsumNav.vue';
import FsumHeader from '@/components/FsumHeader.vue';

const leftDrawerOpen = ref(false);
const toggleLeftDrawer = () => {
    leftDrawerOpen.value = !leftDrawerOpen.value;
};
</script>

<template>
    <q-layout view="hHh LpR fFf">
        <FsumHeader
            :left-drawer-open="leftDrawerOpen"
            toggleable-side-nav
            @toggle-left-drawer="toggleLeftDrawer"
        />
        <q-drawer
            id="fsum-side-menu"
            v-model="leftDrawerOpen"
            show-if-above
            side="left"
            :width="265"
            :breakpoint="767"
        >
            <div class="fsum-nav full-height">
                <FsumNav />
            </div>
        </q-drawer>

        <q-page-container
            id="fsum-main-panel"
            class="col-10 bg-gray"
        >
            <RouterView />
            <q-page-scroller
                position="bottom-right"
                :scroll-offset="300"
                :offset="[14, 14]"
            >
                <q-btn
                    fab-mini
                    icon="keyboard_arrow_up"
                    color="dark-blue"
                />
            </q-page-scroller>
        </q-page-container>
    </q-layout>
</template>
<style scoped lang="scss">
#fsum-main-panel {
    min-height: 100vh;
    z-index: 1;
    padding: 24px;

    @media screen and (max-width: $breakpoint-md-min) {
        padding: 16px;
    }
}
#fsum-below-header {
    padding-top: var(--fsum-header-height);
}
#fsum-side-menu div.fsum-nav {
    padding: 20px 20px 0px 20px;
    width: inherit;
}
:deep(.q-drawer--mobile div#fsum-side-menu) {
  margin-top: 40px;
}
</style>
